import { Box, CircularProgress, Typography } from "@mui/material";
import { Navigate, useParams } from "react-router-dom";

import Layout from "components/Layout";
import { useGetPdfJobQuery } from "features/pdfTools/pdfTools";
import { isSplitJobId, splitJobPathForPayload } from "./splitRoutes";

/**
 * /splitting-tools/:jobId - the old Splitting Tools address, still in Slack
 * cards and in toasts a browser kept. The job is looked up once and the
 * address replaced with its place in Bots Management.
 */
export default function SplitJobLegacyRedirect() {
  const { jobId } = useParams<{ jobId?: string }>();
  const valid = isSplitJobId(jobId);
  const { data: job, isError } = useGetPdfJobQuery(jobId ?? "", { skip: !valid });

  if (!valid || isError) return <Navigate to="/bots-management" replace />;
  if (job) return <Navigate to={splitJobPathForPayload(job)} replace />;
  return (
    <Layout title="Bots Management" content="Bots Management" noScroll>
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          py: 6,
        }}
      >
        <CircularProgress size={22} />
        <Typography color="text.secondary">Opening the split job...</Typography>
      </Box>
    </Layout>
  );
}
